// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-screen {
  font-family: Inter, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #fff7ed;
  padding: 2rem 1.5rem;
  text-align: center;
  box-sizing: border-box;
}

.welcome-screen__logo {
  height: clamp(72px, 12vw, 110px);
  width: auto;
  margin-bottom: 2rem;
  display: block;
}

.welcome-screen__title {
  margin: 0 0 1.75rem;
  font-size: clamp(1.15rem, 4.2vw, 3rem);
  font-weight: 700;
  line-height: 1.15;
  color: #1f2937;
  max-width: 760px;
}

.welcome-screen__actions {
  display: flex;
  gap: 1rem;
  width: 100%;
  max-width: 460px;
  justify-content: center;
  align-items: stretch;
}

.welcome-screen__actions .welcome-btn.p-button {
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  margin: 0;
  justify-content: center;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 12px;
  padding: 0.7rem 1rem;
}

.welcome-screen__actions .welcome-btn--primary.p-button {
  background: #fa7317 !important;
  border: 1px solid #fa7317 !important;
  color: #fff !important;
}

.welcome-screen__actions .welcome-btn--primary.p-button:hover {
  background: #e56610 !important;
  border-color: #e56610 !important;
  color: #fff !important;
}

.welcome-screen__actions .welcome-btn--secondary.p-button {
  background: #fff !important;
  border: 1px solid #fa7317 !important;
  color: #fa7317 !important;
}

.welcome-screen__actions .welcome-btn--secondary.p-button:hover {
  background: #fff8f4 !important;
  border-color: #e56610 !important;
  color: #e56610 !important;
}

.welcome-screen__help-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1.25rem;
  padding: 0.35rem 0.5rem;
  border: none;
  background: transparent;
  color: #c2410c;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: rgba(194, 65, 12, 0.35);
}

.welcome-screen__help-trigger:hover {
  color: #9a3412;
  text-decoration-color: rgba(154, 52, 18, 0.55);
}

.welcome-screen__help-trigger .pi {
  font-size: 0.95rem;
}

/* Drawer — Cómo funciona */
.welcome-help-drawer.p-sidebar {
  width: min(400px, 100vw);
  background: #fff;
  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);
}

.welcome-help-drawer .p-sidebar-header {
  padding: 0.85rem 1rem 0;
  justify-content: flex-end;
}

.welcome-help-drawer .p-sidebar-content {
  padding: 0 1.25rem 1.5rem;
}

.welcome-help-drawer__body {
  text-align: left;
}

.welcome-help-drawer__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.welcome-help-drawer__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.welcome-help-drawer__eyebrow {
  margin: 0 0 0.1rem;
  color: #c2410c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.welcome-help-drawer__title {
  margin: 0;
  color: #1f2937;
  font-size: 1.2rem;
  line-height: 1.25;
}

.welcome-help-drawer__lead {
  margin: 0 0 1rem;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.5;
}

.welcome-help-drawer__steps {
  margin: 0;
  padding-left: 1.2rem;
  color: #4b5563;
  font-size: 0.92rem;
  line-height: 1.45;
}

.welcome-help-drawer__steps li + li {
  margin-top: 0.45rem;
}

.welcome-help-drawer__tip {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid #fee2c5;
  color: #0f766e;
  font-size: 0.88rem;
  line-height: 1.4;
}

.welcome-help-drawer__tip .pi {
  margin-top: 0.1rem;
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .welcome-screen {
    padding: 1.5rem 1rem;
  }

  .welcome-screen__logo {
    height: 64px;
    margin-bottom: 1.5rem;
  }

  .welcome-screen__title {
    margin-bottom: 1.5rem;
    font-size: clamp(1rem, 4.8vw, 1.75rem);
  }

  .welcome-screen__actions {
    flex-direction: column;
    gap: 0.75rem;
    max-width: 100%;
  }

  .welcome-screen__actions .welcome-btn.p-button {
    width: 100%;
    flex: none;
  }

  .welcome-help-drawer.p-sidebar {
    width: 100vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WelcomeScreen.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".welcome-screen {\n  font-family: Inter, sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background-color: #fff7ed;\n  padding: 2rem 1.5rem;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.welcome-screen__logo {\n  height: clamp(72px, 12vw, 110px);\n  width: auto;\n  margin-bottom: 2rem;\n  display: block;\n}\n\n.welcome-screen__title {\n  margin: 0 0 1.75rem;\n  font-size: clamp(1.15rem, 4.2vw, 3rem);\n  font-weight: 700;\n  line-height: 1.15;\n  color: #1f2937;\n  max-width: 760px;\n}\n\n.welcome-screen__actions {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  max-width: 460px;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.welcome-screen__actions .welcome-btn.p-button {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 44px;\n  margin: 0;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.95rem;\n  border-radius: 12px;\n  padding: 0.7rem 1rem;\n}\n\n.welcome-screen__actions .welcome-btn--primary.p-button {\n  background: #fa7317 !important;\n  border: 1px solid #fa7317 !important;\n  color: #fff !important;\n}\n\n.welcome-screen__actions .welcome-btn--primary.p-button:hover {\n  background: #e56610 !important;\n  border-color: #e56610 !important;\n  color: #fff !important;\n}\n\n.welcome-screen__actions .welcome-btn--secondary.p-button {\n  background: #fff !important;\n  border: 1px solid #fa7317 !important;\n  color: #fa7317 !important;\n}\n\n.welcome-screen__actions .welcome-btn--secondary.p-button:hover {\n  background: #fff8f4 !important;\n  border-color: #e56610 !important;\n  color: #e56610 !important;\n}\n\n.welcome-screen__help-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 1.25rem;\n  padding: 0.35rem 0.5rem;\n  border: none;\n  background: transparent;\n  color: #c2410c;\n  font: inherit;\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-color: rgba(194, 65, 12, 0.35);\n}\n\n.welcome-screen__help-trigger:hover {\n  color: #9a3412;\n  text-decoration-color: rgba(154, 52, 18, 0.55);\n}\n\n.welcome-screen__help-trigger .pi {\n  font-size: 0.95rem;\n}\n\n/* Drawer — Cómo funciona */\n.welcome-help-drawer.p-sidebar {\n  width: min(400px, 100vw);\n  background: #fff;\n  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);\n}\n\n.welcome-help-drawer .p-sidebar-header {\n  padding: 0.85rem 1rem 0;\n  justify-content: flex-end;\n}\n\n.welcome-help-drawer .p-sidebar-content {\n  padding: 0 1.25rem 1.5rem;\n}\n\n.welcome-help-drawer__body {\n  text-align: left;\n}\n\n.welcome-help-drawer__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.welcome-help-drawer__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n}\n\n.welcome-help-drawer__eyebrow {\n  margin: 0 0 0.1rem;\n  color: #c2410c;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.welcome-help-drawer__title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.2rem;\n  line-height: 1.25;\n}\n\n.welcome-help-drawer__lead {\n  margin: 0 0 1rem;\n  color: #374151;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.welcome-help-drawer__steps {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: #4b5563;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.welcome-help-drawer__steps li + li {\n  margin-top: 0.45rem;\n}\n\n.welcome-help-drawer__tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin-top: 1.15rem;\n  padding-top: 1rem;\n  border-top: 1px solid #fee2c5;\n  color: #0f766e;\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.welcome-help-drawer__tip .pi {\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 520px) {\n  .welcome-screen {\n    padding: 1.5rem 1rem;\n  }\n\n  .welcome-screen__logo {\n    height: 64px;\n    margin-bottom: 1.5rem;\n  }\n\n  .welcome-screen__title {\n    margin-bottom: 1.5rem;\n    font-size: clamp(1rem, 4.8vw, 1.75rem);\n  }\n\n  .welcome-screen__actions {\n    flex-direction: column;\n    gap: 0.75rem;\n    max-width: 100%;\n  }\n\n  .welcome-screen__actions .welcome-btn.p-button {\n    width: 100%;\n    flex: none;\n  }\n\n  .welcome-help-drawer.p-sidebar {\n    width: 100vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
